import type { EmploymentStatus } from "@/types";

/** Libellés de la situation d'un enseignant ou d'un membre du personnel (valeurs du backend). */
export const EMPLOYMENT_STATUS_LABEL: Record<EmploymentStatus, string> = {
  ACTIVE: "Actif",
  ON_LEAVE: "En congé",
  INACTIVE: "Inactif",
};

export const EMPLOYMENT_STATUS_TONE: Record<EmploymentStatus, "success" | "accent" | "neutral"> = {
  ACTIVE: "success",
  ON_LEAVE: "accent",
  INACTIVE: "neutral",
};

export const EMPLOYMENT_STATUSES = Object.keys(EMPLOYMENT_STATUS_LABEL) as EmploymentStatus[];
